import { ErrorCode } from '@shared/constants/file';

export type ImageObject =
	| {
			filename?: string;
			data?: string;
	  }
	| {
			filename?: string;
			data?: string;
			forceUpdate?: boolean;
			forceRemove?: boolean;
	  };

export const handleImageUpload = ({
	defaultValue,
	value,
	filename,
	shouldDelete = false,
}: {
	defaultValue?: string;
	value?: string;
	filename?: string;
	shouldDelete?: boolean;
}): ImageObject | undefined => {
	if (defaultValue && shouldDelete) return { forceRemove: true };
	if (shouldDelete) return { forceRemove: true };

	// handle create and update entity

	const createObject = {
		filename,
		data: value,
	};

	const updateObject = {
		...createObject,
		forceUpdate: true,
	};

	return defaultValue ? updateObject : createObject;
};

export const validateFile = ({
	file,
	maxSize,
	minSize,
	accept,
}: {
	file: File;
	maxSize: number;
	minSize: number;
	accept: string[];
}): ErrorCode | undefined => {
	const { size, name } = file;
	if (size < minSize) return ErrorCode.FileTooSmall;
	if (size > maxSize) return ErrorCode.FileTooLarge;

	// Check MIME type first
	if (accept?.includes(file.type)) return;
	if (accept?.some((typeRaw) => typeRaw.split(',').includes(file.type))) return;

	// Fallback: Check file extension (important for Windows HEIC files with empty MIME type)
	const extension = name.split('.').pop()?.toLowerCase();
	if (extension && accept?.some((typeRaw) => typeRaw.includes(`.${extension}`)))
		return;

	return ErrorCode.FileInvalidType;
};
